(function (angular, window) {
  "use strict";

  angular.module("Toyota").directive("tyAddNewVehicleToWishlist", [
    "$rootScope",
    "$location",
    "$timeout",
    "Wishlist",
    "DebugLogger",
    function ($rootScope, $location, $timeout, Wishlist, DebugLogger) {
      return {
        scope: true,
        restrict: "A",
        link: function (scope, element, attrs) {
          scope.isOnWishlist = false;

          $rootScope.$on(
            "pricing-page-material-code-paint-loaded",
            function (e, materialCode) {
              DebugLogger.log(
                "tyAddNewVehicleToWishlist",
                "pricing-page-material-code-paint-loaded:",
                materialCode
              );
              if (materialCode === scope.pricingPageMaterialCode) {
                return;
              }

              scope.pricingPageMaterialCode = materialCode;
              scope.isOnWishlist = false;
            }
          );

          Wishlist.onAddNewVehicleToWishlistSuccess((e) => {
            scope.isOnWishlist = true;
            DebugLogger.log(
              "tyAddNewVehicleToWishlist",
              "onAddNewVehicleToWishlistSuccess handler fired with event data:",
              e
            );
            scope.$digest();
          });

          element.on("click", function (e) {
            const materialCode = scope.pricingPageMaterialCode;
            Wishlist.addNewVehicleToWishlist(materialCode);
            e.preventDefault();
          });
        },
      };
    },
  ]);
})(window.angular, window);
